export const SET_WIDGET_CUSTOMISATIONS = "SET_WIDGET_CUSTOMISATIONS ";

export const setWidgetCustomisations = payload => ({
  type: SET_WIDGET_CUSTOMISATIONS,
  payload
});
